import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import axios from "axios";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {InputText} from "primereact/inputtext";
import '../../css/DataTableDemo.css'
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";

const ModuleSubscription = props => {
    const toast = useRef(null);
    const [userList, setUserList] = useState([]);
    const dt = useRef(null);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [subID, setSubID] = useState(null);
    const [moduleList, setModuleList] = useState([]);
    const md_user_list_role = localStorage.getItem('md_user_list') ? true : false;


    useEffect(() => {

        getUserList()
        getModuleList()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.


    const getUserList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/md-user/', {"headers": headers})
            .then(res => {
                setUserList(res.data.user_list)
            })
    }


    const customer1TableHeader = (
        <div className="table-header" align="right">
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );


    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteCip(subID)} autoFocus/>
            </div>
        );
    }
    const deleteRow = (subID) => {


        setCipDeleteDialog(true)
        setSubID(subID)


    }
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            detail: message,
            life: 3000
        });
    }


    const deleteCip = (subID) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.delete('/api/md-user-delete' + `/${subID}/`, {"headers": headers})
            .then(res => {

                const data = res.data;
                if (data.result) {
                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }


                getUserList();

                setCipDeleteDialog(false)
                setSubID(null)

            }).then(res => {
            if (res.status === 401) {
                props.loadUser();
                throw res.data;
            } else if (res.status === 403) {
                throw res.data;
            }
        })
        ;


    };
    const getModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/module/list/', {"headers": headers})
            .then(res => {

                setModuleList(res.data)
            })
    }

    const actionTemplate = (rowData) => {
        //    ////console.log(rowData['cip_id'])
        return <div>
            <div>

            </div>
            <Button
                type="submit"
                title="Sil"
                icon="pi pi-trash"
                className="p-button-danger p-mr-3"
                onClick={() => deleteRow(rowData['sub_id'])}
                style={{maxHeight: '2em', maxWidth: '2em'}}
            >
            </Button>


        </div>;
    }

    if (md_user_list_role) {

        return (

            <div>
                <Toast ref={toast}/>


                <Dialog header="UYARI" visible={cipDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}

                        onHide={() => setCipDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Silmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>


                <div className="datatable-responsive-demo">

                    <div className="card">
                        <h5><b>e-Bülten Kayıtlı Kullanıcılar</b></h5>
                        <p>Sayfalandırma, sıralama ve filtreleme </p>

                        <DataTable
                            ref={dt}
                            value={userList}
                            paginator
                            className="p-datatable-responsive-demo"
                            rows={10} dataKey="id"
                            rowHover
                            globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                            header={customer1TableHeader}
                        >

                            <Column field={'sub_id'}
                                    header="ID"
                                    sortable

                            />


                            <Column
                                field={'sub_email'}
                                header="E-Mail"
                                sortable
                                filter


                            />

                            <Column
                                field={'sub_createtime'}
                                header="Kayıt Zamanı"
                                sortable
                                filter


                            />

                            <Column
                                header="İşlevler"
                                body={actionTemplate}

                            />


                        </DataTable>

                    </div>

                </div>
            </div>


        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModuleSubscription);


// WEBPACK FOOTER //
// ./src/pages/modulemanagement/ModuleSubScription.jsx